
  import * as storyblokRuntime$y5Oor8faPo6kpl66JYEDJzytLH9mMm7ns9wEVORdUpk from '/opt/build/repo/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as netlifyRuntime$uybova2k88oFQ7_45ewGz9EaJi2q_45BkIKIuCgbTiQPzPc from '/opt/build/repo/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/netlifyImageCdn'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "netlify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$y5Oor8faPo6kpl66JYEDJzytLH9mMm7ns9wEVORdUpk, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['netlify']: { provider: netlifyRuntime$uybova2k88oFQ7_45ewGz9EaJi2q_45BkIKIuCgbTiQPzPc, defaults: {} }
    }
  }
